<script setup lang="ts">
import { useUrlSearchParams } from "@vueuse/core"
import { ref, watchEffect } from "vue"
import { onBeforeRouteLeave } from "vue-router"
import { MediaTable } from "@/components"
import { useConvertedRouteParam } from "@/composables"
import { SidebarHostEventLayout } from "@/layouts"

definePage({
  meta: {
    requiresAuth: true,
  },
})

const eventVaultId = useConvertedRouteParam("id", "/event/[id]/manage-media", value => Number(value))
const albumId = ref<number | undefined>()
const queryParams = useUrlSearchParams<{ album?: number }>()
const mediaTableRef = ref<InstanceType<typeof MediaTable> | null>(null)

watchEffect(() => {
  if (queryParams.album)
    albumId.value = queryParams.album
})

onBeforeRouteLeave(() => {
  mediaTableRef.value?.closePopovers()
})
</script>

<template>
  <SidebarHostEventLayout>
    <div>
      <MediaTable ref="mediaTableRef" :event-vault-id="eventVaultId" :album-id="albumId" />
    </div>
  </SidebarHostEventLayout>
</template>
